module.exports = __webpack_public_path__ + "img/specif_srb.1d119c5f.jpg";